import React from 'react';
import { ArrowDown } from 'react-feather';
import classNames from 'classnames';

interface ScrollToBottomButtonProps {
    onClick: () => void;
    isVisible: boolean;
}

const ScrollToBottomButton: React.FC<ScrollToBottomButtonProps> = ({ onClick, isVisible }) => {
    if (!isVisible) {
        return null;
    }

    return (
        <button
            onClick={onClick}
            className={classNames(
                'absolute bottom-20 left-1/2 transform -translate-x-1/2', // Position: Horizontally centered, a bit above the chat input
                'bg-white dark:bg-saga-gray-800 rounded-full p-2.5 shadow-button', // Appearance: Circle, shadow
                'hover:bg-gray-100 dark:hover:bg-saga-gray-700 transition-colors duration-200', // Hover effect
                'z-50', // Ensure it's above other elements
            )}
            aria-label="Scroll to bottom"
        >
            <ArrowDown className="text-saga-gray-500 dark:text-saga-gray-400" size={16} />
        </button>
    );
};

export default ScrollToBottomButton;
